import LineChart from './lineChart.component';

export default LineChart;